import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: {
    current_user: null,
    current_user_details: null,
    isLoading: true,
    isLoaded: false,
  },
  logoutTimer: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    getCurrentUser: (state, { payload }) => {
      state.currentUser = payload;
    },
    setLogoutTimer: (state, { payload }) => {
      state.logoutTimer = payload;
    },
  },
});

export const { getCurrentUser, setLogoutTimer } = authSlice.actions;

export default authSlice.reducer;
